//dependencias
import React, { Component } from 'react';

//componentes
import ReporteEvaPendAction from './reporteEvapend'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteEvaPendAction />
            </div>
        );
    }

}
export default Index;